// 计算请求统计方法, 注册成一个全局数据, 随时都可以拿到
import axios from '@/plugins/axios'
/**
 * @class Request 请求类，会对使用该类发送对请求数进行统计
 * @param {number} requestCount 正在进行的计算请求数量
 * */
let requestCount = 0
class AsyncRequest {
  /**
   * @param requestType 请求方法 get/post
   * @param path 当前计算请求路径
   * @param data 请求参数
   * @param type 实例化该类对对象类型 calcRequest/relationRequest(计算请求/关联请求)
   * */
  type
  requestType
  path
  data
  constructor ({type, requestType, path, data}) {
    if (!requestType) {
      throw new Error('error:缺少请求类型!')
    }
    if (!path) {
      throw new Error('error:缺少请求地址!')
    }
    this.type = type
    this.requestType = requestType && requestType.toLowerCase()
    this.path = path
    this.data = data
  }
  static validRequest () {
    return new Promise((resolve, reject) => {
      // 点击按钮之前的操作都是同步的, 会导致请求还没发就进了这里来判断, 所以这里要延后0.1s
      // 等待超过15秒之后直接放掉
      let waitTime = 0
      // todo: 有比延迟更严谨的处理方法 - 判断控件需要走几次计算进行存储
      let checkRequestInterval = setInterval(() => {
        waitTime += 100
        console.log(waitTime)
        if (requestCount === 0 || waitTime > 15000) {
          resolve()
          clearInterval(checkRequestInterval)
        }
      }, 110)
    })
  }

  // 获取请求参数
  getConfig () {
    let type = this.type
    let config = {
      method: this.requestType,
      url: this.path,
      transformResponse: [function (data) {
        if (type === 'calcRequest') {
          return typeof data === 'number' ? data.request.response : data
        }
        if (type === 'relationRequest') {
          let parseData = data
          try {
            parseData = JSON.parse(data)
          } catch (e) {
          }
          return parseData
        }
        return data
        // 处理数字长度过长导致精度丢失问题
      }]
    }
    switch (this.requestType) {
      case 'post':
        config.data = this.data
        break
      case 'get':
        config.params = this.data
        break
    }
    return config
  }

  async sendRequest () {
    // 发送请求
    requestCount += 1
    try {
      let config = this.getConfig()
      let data = await axios(config)
      return data
    } finally {
      this.finishRequest()
    }
  }
  // 请求结束或者终止
  finishRequest () {
    // 因为计算或关联请求是使用的 $watcher 进行的观测，所以嵌套的下一轮计算或关联请求会在异步渲染完vnode后发送
    // 所以这里不能使用同步代码直接去减少统计数，至少要等到 $watcher 的下一轮 nextTick 走完之后才能去减少
    if (requestCount > 0) {
      setTimeout(() => {
        requestCount -= 1
      }, 100)
    } else {
      requestCount = 0
    }
  }
}

export {AsyncRequest}



// WEBPACK FOOTER //
// ./src/components/form/runtime/components/utils/AjaxRequestLimit.js